module.exports = __webpack_public_path__ + "img/1.a49a1fe5.svg";